import { Dropdown } from "primereact/dropdown";

const AIEduDropDown = (props) => {
    return <Dropdown {...props} />;
};

export default AIEduDropDown;
